<div
  class="rounded-2xl border p-4"
  [attr.data-testid]="testId()"
  [class.border-teal-200]="highlighted() && colorScheme() === 'teal'"
  [class.bg-teal-50]="highlighted() && colorScheme() === 'teal'"
  [class.border-amber-200]="highlighted() && colorScheme() === 'amber'"
  [class.bg-amber-50]="highlighted() && colorScheme() === 'amber'"
  [class.border-slate-200]="!highlighted()"
  [class.bg-white]="!highlighted()"
>
  <div class="flex items-center gap-3">
    <div
      class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl"
      [class.bg-teal-100]="colorScheme() === 'teal'"
      [class.bg-amber-100]="colorScheme() === 'amber'"
      [class.bg-slate-100]="!colorScheme()"
    >
      <i [attr.class]="iconClass()"></i>
    </div>
    <div>
      <div class="text-2xl font-bold text-slate-900">{{ count() }}</div>
      <div class="text-xs text-slate-500">{{ label() }}</div>
    </div>
  </div>
</div>
